"use strict";

var _objectSpread = require("/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatProof = void 0;
const index_js_1 = require("../index.js");
function formatStorageProof(storageProof) {
  return storageProof.map(proof => _objectSpread(_objectSpread({}, proof), {}, {
    value: BigInt(proof.value)
  }));
}
function formatProof(proof) {
  return _objectSpread(_objectSpread({}, proof), {}, {
    balance: proof.balance ? BigInt(proof.balance) : undefined,
    nonce: proof.nonce ? (0, index_js_1.hexToNumber)(proof.nonce) : undefined,
    storageProof: proof.storageProof ? formatStorageProof(proof.storageProof) : undefined
  });
}
exports.formatProof = formatProof;
//# sourceMappingURL=proof.js.map